// extracted by mini-css-extract-plugin
export default {"btnAction":"OrganizationsSection_btnAction__zl8RJ","title":"OrganizationsSection_title__T-j1W"};